import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { OfficialDiarySearchProvider } from './context/official-diary-search-context';
import { OfficialDiarySearchComponent } from './official-diary-search-component';

export function OfficialDiarySearchFactory() {
    return (
        <BaseLayoutFactory>
            <OfficialDiarySearchProvider>
                <OfficialDiarySearchComponent />
            </OfficialDiarySearchProvider>
        </BaseLayoutFactory>
    );
}
